module.exports = __webpack_public_path__ + "media/app/assets/races/zandalari_troll_male-6a2fef4934d30b70863c9c367242f600.png";